import React, {Component} from 'react'

type ProgressBarProps = {
  valueNow: number
  step: string
}

class ProgressBar extends Component<ProgressBarProps> {
  render() {
    return (
      <div className="progress" role="progressbar" aria-valuenow={this.props.valueNow} aria-valuemin={0} aria-valuemax={100}>
        <div className={"bar " + this.props.step}/>
      </div>
    )
  }
}

export default ProgressBar
